export const POLICY_BARBARISM_UNIT_D6_PRICE = 0;

export const POLICY_BARBARISM_UNIT_MELEE_BONUS = 2;

export const POLICY_BARBARISM_MELEE_DAMAGE_WIN_POINTS_BONUS = 1;

export const POLICY_BARBARISM_UNIT_SIZE_DECREASE_WITHOUT_SUPPLY = -1;

